import { EventEmitter } from 'events';

class WasmEventReceiver extends EventEmitter {}

let receiver: EventEmitter | null = null;

export function registerEventReceiver(cb: (evt: string) => void) {
  if (receiver) {
    throw new Error('Has been registered.');
  }
  receiver = new WasmEventReceiver();
  window.onWasmEvent = evt => {
    // Defer all wasm-driven UI updates to avoid re-entering wasm while a mutable
    // borrow is still active in the original Rust call stack.
    setTimeout(() => {
      if (evt.startsWith('edit_text:')) {
        const elementId = evt.substring('edit_text:'.length);
        receiver?.emit('edit_text', elementId);
      }
      cb(evt);
    }, 0);
  };
}

export function onTextEdit(callback: (elementId: string) => void) {
  if (!receiver) {
    throw new Error('Event receiver not registered.');
  }
  receiver.on('edit_text', callback);
  return () => {
    receiver?.off('edit_text', callback);
  };
}
